import React from "react";
import MenuIds from "./MenuIds";
import MenuItemDivider from "./menuItemDivider";
import BrandsAndServices from "../brandsAndServices/brandsAndServices";
import { ITabSetCategory } from "../../interfaces/ITabSetCategory";
import { IBrandOrService } from "../brandsAndServices/brandOrService";

export interface IShopByCategoryMenuProps {
  categories: ITabSetCategory[];
  brandsAndServices: IBrandOrService[];
  pushMenuStack: (
    id: string | undefined,
    label: string | undefined,
    icon: string | undefined,
    svg: (() => React.ReactNode) | undefined,
    src: string | undefined,
    href: string | undefined,
    subMenuUseHref: boolean | undefined,
    linkClass: string | undefined,
    extras: unknown | undefined
  ) => void;
}

function renderCategoryInner(
  props: IShopByCategoryMenuProps,
  category: ITabSetCategory
) {
  const buttonProps: Record<string, unknown> = {};
  if (category.hasMenu) {
    buttonProps.onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      props.pushMenuStack(
        MenuIds.MEGA_MENU,
        category.name,
        undefined,
        undefined,
        category.mobileMenuIconImage,
        category.linkUrl,
        true,
        "menu-item-link",
        category
      );
      event.preventDefault();
    };
  }

  return (
    <button className="category-button-shop-by" {...buttonProps}>
      <img
        src={category.mobileMenuIconImage}
        alt={category.name + " Icon"}
      ></img>
      <div>{category.name}</div>
    </button>
  );
}

function renderCategory(
  props: IShopByCategoryMenuProps,
  category: ITabSetCategory
) {
  return category.hasMenu ? (
    renderCategoryInner(props, category)
  ) : (
    <a href={category.linkUrl}>{renderCategoryInner(props, category)}</a>
  );
}

function mapCategoriesToRows(props: IShopByCategoryMenuProps) {
  const categories = props.categories;

  const rows = [];

  for (let i = 0; i < categories.length; i += 3) {
    const category1 = categories[i];
    const category2 = i + 1 < categories.length ? categories[i + 1] : null;
    const category3 = i + 2 < categories.length ? categories[i + 2] : null;

    rows.push(
      <div className="row form-group" key={i}>
        <div className="col-4">{renderCategory(props, category1)}</div>
        {category2 && (
          <div className="col-4">{renderCategory(props, category2)}</div>
        )}
        {category3 && (
          <div className="col-4">{renderCategory(props, category3)}</div>
        )}
      </div>
    );
  }

  return rows;
}

const renderBrandAndServices = (brandsAndServices: IBrandOrService[]) => {
  return brandsAndServices.length > 0 ? (
    <React.Fragment>
      <MenuItemDivider />
      <div>
        <b className="font-weight-bold">More Brands & Services</b>
      </div>
      <BrandsAndServices brandsAndServices={brandsAndServices} mobile />
    </React.Fragment>
  ) : null;
};

function ShopByCategoryMenu(props: IShopByCategoryMenuProps) {
  return (
    <>
      <div>{props.categories && mapCategoriesToRows(props)}</div>
      {renderBrandAndServices(props.brandsAndServices)}
    </>
  );
}

export default ShopByCategoryMenu;
